/**
 * App-nivå typer. Speglar API:t. Den dag vi lyfter ut shared types till
 * ett delat paket konsumerar både API:t och appen samma definitioner.
 */

import type { HourPoint } from "./sim/types";

export type DataSource =
  | "tibber-oauth"
  | "tibber-pat"
  | "eon-csv"
  | "vattenfall-csv"
  | "ellevio-csv"
  | "profile-estimate";

export type DataQuality = "measured" | "modeled" | "mixed";
export type Resolution = "quarter" | "hour" | "day";
export type PriceArea = "SE1" | "SE2" | "SE3" | "SE4";

export interface TibberHome {
  id: string;
  nickname: string | null;
  address: {
    address1: string | null;
    postalCode: string | null;
    city: string | null;
  };
  gridArea: string | null;
  priceArea: PriceArea | null;
}

export interface UserDataMetadata {
  source: DataSource;
  fetchedAt: string;
  resolution: Resolution;
  quality: DataQuality;
  periodFrom: string;
  periodTo: string;
  hourCount: number;
  totalImport: number;
  totalExport: number;
  tibberHome?: TibberHome;
  hoursWithMissingPrice?: number;
  hoursWithMissingProduction?: number;
  /**
   * Wizard-input som genererade datan. Endast satt när source =
   * 'profile-estimate'. Används för:
   *   1. Post-wizard-justering: regenerera när användaren drar i sliders
   *   2. Dela-länk: serialisera till URL så mottagaren ser samma kalkyl
   */
  wizardInput?: import("./data-sources/wizardGenerator").WizardInput;
}

export interface UserData {
  metadata: UserDataMetadata;
  hours: HourPoint[];
}

/** Mänskligt läsbart namn för en datakälla. */
export function describeSource(source: DataSource): string {
  switch (source) {
    case "tibber-oauth":
      return "Tibber";
    case "tibber-pat":
      return "Tibber (token)";
    case "eon-csv":
      return "E.on (CSV)";
    case "vattenfall-csv":
      return "Vattenfall (CSV)";
    case "ellevio-csv":
      return "Ellevio (CSV)";
    case "profile-estimate":
      return "Uppskattad från profil";
  }
}
